module.exports = __webpack_public_path__ + "static/media/OperatorBulkUpload.40bb254a.xlsx";